import React, { useEffect, useState } from 'react';
import css from './SectionFlipAndWin.css';
import { useRequest } from '../../../../hooks/useRequest';
import { Alert, IconSpinner } from '../../../../components';
import { Counter } from './Counter';
import { FlipAndWinCards } from './FlipAndWinCards';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrentUser, updateUserProfileInfo } from '../../../../ducks/user.duck';
import Partners from './partners';
import { evaluateFlipOutcome, getFlipAndWinCards } from '../../../../util/api';

export default () => {
    const dispatch = useDispatch();
    const currentUser = useSelector(state => state.user.currentUser);

    const [cards, setCards] = useState([{}, {}, {}]);
    const [fetchingCardsError, setFetchingCardsError] = useState(null);

    const updateUserProfile = params => dispatch(updateUserProfileInfo(params));
    const fetchCurrentUserData = async () => await dispatch(fetchCurrentUser());

    const { flipAndWinData } = currentUser?.attributes?.profile?.privateData || {
        flipAndWinData: {},
    };
    const { newFlipAllowedAt } = flipAndWinData || { cardsFlipped: {} };

    const { loading: fetchingCardsLoading, request: fetchingCardsRequest } = useRequest();

    const {
        error: evaluatingCardError,
        loading: evaluatingCardLoading,
        request: evaluatingCardRequest,
    } = useRequest();

    const errors = fetchingCardsError || evaluatingCardError;

    const requestCards = async () =>
        await fetchingCardsRequest(getFlipAndWinCards, setCards, e => {
            const isNotAuthed = e.status === 401;
            if (!isNotAuthed) {
                setFetchingCardsError(e.message || 'Something went wrong, try later.');
            }
        });

    useEffect(() => {
        requestCards();
    }, []);

    if (fetchingCardsLoading) return <IconSpinner />;

    if (errors) {
        return <Alert showAsPlainText type="failure" description={errors} closeAllowed={false} />;
    }

    const handleCardFlip = card =>
        evaluatingCardRequest(
            async () => await evaluateFlipOutcome(card.id),
            unflippedCard => {
                setCards(prev =>
                    prev.map(existingCard =>
                        existingCard.id === unflippedCard.id ? unflippedCard : existingCard
                    )
                );

                fetchCurrentUserData();
            }
        );

    return (
        <section className={css.root}>
            <div className={css.content}>
                <div>
                    <Counter
                        newFlipAllowedAt={newFlipAllowedAt}
                        updateUserProfile={updateUserProfile}
                        flipAndWinData={flipAndWinData}
                        requestCards={requestCards}
                    />
                    <FlipAndWinCards
                        loading={evaluatingCardLoading}
                        cards={cards}
                        handleCardFlip={handleCardFlip}
                    />
                </div>
            </div>
            <div className={css.partners}>
                <Partners />
                <Partners />
            </div>
        </section>
    );
};
